<template>
  <div class="tpass-warp tpReceiptDetail tpassDetail">
    <loading :show="apiLoading" :isTpass="true"></loading>
    <t-pass-header
      :title="'收據歸戶'"
      :routerUrl="'taipeiPassAppReceiptDetail'"
      :isRecord="isRecord"
      :rpPublicNo="resultData.rpPublicNo"
      :rpPublicRandomCode="resultData.rpPublicRandomCode"
      :receiptToken="receiptToken"
    ></t-pass-header>
    <div class="receipt-card bg-white">
      <div class="receipt-card-header">
        <div v-if="isConsole" class="console">
          <div>Path === {{ this.$route.fullPath }}</div>
          <div>$route.params === {{ $route.params }}</div>
          <div>$route.query === {{ $route.query }}</div>
        </div>
        <t-pass-icon-point ref="tPassIconPoint"></t-pass-icon-point>
      </div>
    </div>
    <t-pass-directions
      ref="tPassDirections"
      :content="content"
      :bgColor="'bg-white'"
    ></t-pass-directions>
    <div class="receipt-footer bg-white">
      <template>
        <b-button
          v-if="resultData.type === 'SUCCESS'"
          :variant="'outline-primary'"
          class="tp-col-6"
          @click="goReceiptDetail()"
          >檢視紀錄</b-button
        >
        <b-button
          :variant="'primary-2'"
          :class="[resultData.type === 'SUCCESS' ? 'tp-col-6' : 'tp-col-12']"
          @click="goReturnHome()"
          >{{ resultData.type === 'SUCCESS' ? '繼續歸戶' : '重新查詢' }}</b-button
        >
      </template>
      <!-- <template v-else>
        <b-button :variant="'primary-2'" class="tp-col-12" @click="goReturnHome()"
          >重新查詢</b-button
        >
      </template> -->
    </div>
  </div>
</template>

<script>
import CommonApiMixin from '@/mixins/commonApi';
import ApiMixin from '@/mixins/api';

export default {
  name: 'TpassReceiptConfirmation',

  mixins: [CommonApiMixin, ApiMixin],

  data() {
    return {
      content: [
        {
          value: '1',
          text:
            '本電子收據系統由機關依個別法規規定應載明事項辦理，對收據劇內容有疑義，請逕洽收據開立機關承辦人。',
        },
        {
          value: '2',
          text: '收據如經作廢，最新狀態請依平台顯示為主。',
        },
        {
          value: '3',
          text: '每張收據僅能歸戶一次，取得收據者可歸戶至台北通帳戶(未限制須為繳款人本人)。',
        },
        {
          value: '4',
          text: '僅限開立日期一年內之收據資料可供查詢及歸戶。',
        },
      ],
      apiLoading: false,
      resultData: {
        type: '',
      },
      receiptToken: '',
      isConsole: false,
      isRecord: false,
    };
  },

  created() {
    this.resultData = this.$route.params.receiptInductData ?? { type: 'info' };
    if (this.$route.params.receiptToken) {
      this.receiptToken = this.$route.params.receiptToken ?? '';
    } else {
      this.receiptToken = this.$route.query.receiptToken ?? '';
    }
    this.isRecord = this.$route.params.isRecord ?? false;
    console.log('this.receiptToken---', this.receiptToken);
    if (!this.receiptToken) {
      this.viewClose();
    }
    let title;
    switch (this.resultData.type) {
      case 'SUCCESS':
        title = '歸戶成功';
        break;
      case 'INDUCTION':
        title = '此收據已被歸戶';
        break;
      case 'ERROR':
        title = '無法歸戶';
        break;
      case 'NOSEARCH':
        title = '查無此收據';
        break;
      default:
        break;
    }
    this.$nextTick(() => {
      this.$refs.tPassIconPoint.changeMsgIcon(
        this.resultData.type,
        title,
        this.resultData.rpPublicNo && this.resultData.type !== 'ERROR'
          ? `收據號碼${this.resultData.rpPublicNo}`
          : '',
        this.resultData.type === 'ERROR' ? '請重新再試一次' : this.resultData.data
      );
    });

    console.log('$route.params', this.$route.params);
  },

  methods: {
    viewClose() {
      window.location = `viewclose://`;
    },
    goReturnHome() {
      this.$router.push({
        name: 'taipeiPassAppReceiptReturnHome',
        params: { receiptToken: this.receiptToken },
      });
    },

    goReceiptDetail() {
      this.$router.push({
        name: 'taipeiPassAppReceiptRecord',
        query: {
          receiptToken: this.receiptToken,
        },
      });
    },

    success(type, result) {
      console.log('result', result);
      this.apiLoading = false;
    },
    fail(type, error) {
      console.log(error);
      this.apiLoading = false;
    },
  },
};
</script>
